import { render, staticRenderFns } from "./MobileNavigation.vue?vue&type=template&id=3dc84437&"
import script from "./MobileNavigation.vue?vue&type=script&lang=js&"
export * from "./MobileNavigation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/stefanschmidt/Entwicklung/plenty24/3672/203/Bigtex5/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('3dc84437')) {
      api.createRecord('3dc84437', component.options)
    } else {
      api.reload('3dc84437', component.options)
    }
    module.hot.accept("./MobileNavigation.vue?vue&type=template&id=3dc84437&", function () {
      api.rerender('3dc84437', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/src/app/bigtex/MobileNavigation.vue"
export default component.exports